/* eslint-disable vue/no-parsing-error */
<template>
  <div class="offer-description-container">
    <p class="h2">{{ position.title }}</p>
    <div v-for="(description, index) in position.description" :key="`offer-descript-${index}`" class="mb-5">
      <p v-if="description.mainTitle" class="h3">{{ description.mainTitle }}</p>
      <p v-if="description.title" class="h4">{{ description.title }}</p>
      <p v-if="description.subtitle" class="h5 mb-5">{{ description.title }}</p>
      <p v-if="description.text">{{ description.text }}</p>
    </div>
    <div v-for="section in position.lists" :key="`offer-descript-list-${section.title}`" class="mb-5">
      <p class="h3" v-if="section.mainTitle">{{ section.mainTitle }}</p>
      <p class="h4" v-if="section.title">{{ section.title }}</p>
      <p class="h5" v-if="section.subtitle">{{ section.subtitle }}</p>
      <ul class="offer-description-list">
        <li v-for="item in section.list" :key="`offer-descript-list-item-${item}`" class="mb-2" v-html="item"></li>
      </ul>
    </div>
    <div
      v-for="(description, index) in position.footerDescription"
      :key="`offer-descript-footer-${index}`"
      class="mb-5"
    >
      <p v-if="description.title" class="h4">{{ description.title }}</p>
      <p v-if="description.text">{{ description.text }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "TOfferDescription",
  props: {
    position: {
      type: Object,
    },
  },
};
</script>
